<template>
<card class='text-muted'>
    <b-icon icon="info-circle" scale='1.5' style='margin-right: 15px'></b-icon> 
    <slot>{{ $t('item.info') }}</slot>
</card>
</template>


<script>
export default {
  name: 'InfoCard'
} 
</script>

<style scoped lang="scss">
.card {
    font-style: italic;
    padding: 20px;
}

</style>